import React from "react";
import dayjs from "dayjs";
import BoardCard from "components/dashboard/BoardCard";
import { DATE_FORMAT } from "config/constant";
import { DashboardTable } from "../DashboardTable";
import { useLatestNoticesQuery } from "features/notice/hooks/queries/useLatestNoticesQuery";
import { ROUTER_PATH } from "config/path";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

const NoticeCard = () => {
  const { data: latestNoticesResponse } = useLatestNoticesQuery();
  const { contents, totalElements } = latestNoticesResponse || {};

  const navigate = useNavigate();

  /**
   * @description 테이블 row 클릭 이벤트 핸들러
   */
  const onClickRow = (uuid: string) => {
    navigate(ROUTER_PATH.notice.dashboard.detail(uuid));
  };

  return (
    <BoardCard title="Notice" to={ROUTER_PATH.notice.dashboard._path}>
      <NoticeTableStyle>
        <DashboardTable.Thead>
          <DashboardTable.Tr>
            <DashboardTable.Th>No.</DashboardTable.Th>
            <DashboardTable.Th>제목</DashboardTable.Th>
            <DashboardTable.Th>등록일</DashboardTable.Th>
          </DashboardTable.Tr>
        </DashboardTable.Thead>
        <DashboardTable.Tbody>
          {contents?.map((item, index) => {
            const articleIndex = totalElements ? totalElements - index : 5;

            return (
              <ClickableRowStyle
                key={item.uuid}
                onClick={() => onClickRow(item.uuid)}
              >
                <DashboardTable.Td>
                  {String(articleIndex).padStart(5, "0")}
                </DashboardTable.Td>
                <DashboardTable.Td>{item.title}</DashboardTable.Td>
                <DashboardTable.Td>
                  {dayjs(item.createdAt).format(DATE_FORMAT)}
                </DashboardTable.Td>
              </ClickableRowStyle>
            );
          })}
        </DashboardTable.Tbody>
      </NoticeTableStyle>
    </BoardCard>
  );
};

export default NoticeCard;

const NoticeTableStyle = styled(DashboardTable.Table)`
  th {
    &:nth-child(1) {
      width: 6.4rem;
    }
    &:nth-child(3) {
      width: 17.2rem;
    }

    ${({ theme }) => css`
      ${theme.media.small} {
        &:nth-child(3) {
          width: 8rem;
        }
      }
    `}
  }

  td {
    &:nth-child(1) {
      color: ${({ theme }) => theme.color.text.tertiery};
      padding-left: 0;
      padding-right: 0;
    }
    &:nth-child(3) {
      color: ${({ theme }) => theme.color.text.secondary};
    }
  }
`;

const ClickableRowStyle = styled(DashboardTable.Tr)`
  cursor: pointer;
`;
